import React from "react"
import classNames from "classnames"

import Icon from "@ng-mw/reol/components/Icon"
import brokkoliIcon from "@resources/icons/brokkoli"
import checkmarkBoldIcon from "@resources/icons/checkmarkBold"
import fish2Icon from "@resources/icons/fish2"
import kalkunIcon from "@resources/icons/kalkun"
import kjottIcon from "@resources/icons/kjott"

import { DinnerSuggestionsMoreOfOption } from "../preferences/types"

interface DinnerSuggestionsSelectionCardProps {
    option: DinnerSuggestionsMoreOfOption
    isSelected: boolean
    onClick: () => void
}

const illustrationByOption = {
    fish: fish2Icon,
    vegetarian: brokkoliIcon,
    chicken: kalkunIcon,
    meat: kjottIcon,
} as const

const DinnerSuggestionsSelectionCard = ({
    option,
    isSelected,
    onClick,
}: DinnerSuggestionsSelectionCardProps) => {
    const illustration = option.illustration ? illustrationByOption[option.illustration] : undefined

    return (
        <button
            type="button"
            className={classNames("dinner-suggestions-popup__option-card", {
                "dinner-suggestions-popup__option-card--selected": isSelected,
            })}
            aria-pressed={isSelected}
            onClick={onClick}
        >
            <span
                className={classNames("dinner-suggestions-popup__option-check", {
                    "dinner-suggestions-popup__option-check--selected": isSelected,
                })}
                aria-hidden="true"
            >
                {isSelected ? (
                    <Icon
                        icon={checkmarkBoldIcon}
                        size={{ width: "16px", height: "16px" }}
                    />
                ) : null}
            </span>
            <span className="dinner-suggestions-popup__option-copy">
                <span className="dinner-suggestions-popup__option-title">{option.label}</span>
            </span>
            {illustration ? (
                <span
                    className={classNames(
                        "dinner-suggestions-popup__option-illustration",
                        option.illustration &&
                            `dinner-suggestions-popup__option-illustration--${option.illustration}`,
                    )}
                    aria-hidden="true"
                >
                    <Icon
                        icon={illustration}
                        size={{ width: "120px", height: "120px" }}
                    />
                </span>
            ) : null}
        </button>
    )
}

export default DinnerSuggestionsSelectionCard
